// app/javascript/controllers/listing_map_controller.js
// Read-only parcel map for the public property page: satellite view with the
// section's boundary drawn and fitted. No drawing, no interaction beyond pan/zoom.

import { Controller } from "@hotwired/stimulus"
import mapboxgl from "mapbox-gl"

export default class extends Controller {
  static targets = ["map"]
  static values = {
    accessToken: String,
    geojson: String    // sub_parcel polygon (GeoJSON geometry)
  }

  connect() {
    if (!this.accessTokenValue || !this.geojsonValue) return
    mapboxgl.accessToken = this.accessTokenValue

    let geometry
    try {
      geometry = JSON.parse(this.geojsonValue)
    } catch {
      return
    }

    this.map = new mapboxgl.Map({
      container: this.mapTarget,
      style: "mapbox://styles/mapbox/satellite-streets-v12",
      bounds: this.boundsFor(geometry),
      fitBoundsOptions: { padding: 40 },
      cooperativeGestures: true
    })

    this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }))

    this.map.on("load", () => {
      this.map.addSource("parcel", {
        type: "geojson",
        data: { type: "Feature", geometry, properties: {} }
      })
      this.map.addLayer({
        id: "parcel-fill", type: "fill", source: "parcel",
        paint: { "fill-color": "#10b981", "fill-opacity": 0.15 }
      })
      this.map.addLayer({
        id: "parcel-outline", type: "line", source: "parcel",
        paint: { "line-color": "#10b981", "line-width": 2.5 }
      })
    })
  }

  boundsFor(geometry) {
    const bounds = new mapboxgl.LngLatBounds()
    const walk = (coords) => {
      if (typeof coords[0] === "number") bounds.extend(coords)
      else coords.forEach(walk)
    }
    walk(geometry.coordinates)
    return bounds
  }

  disconnect() {
    this.map?.remove()
  }
}
